<template>
  <div class="issue-type flex flex-col gap-4">
    <v-select 
      v-model="selectedLevel1" 
      :options="options" 
      label="label" 
      :searchable="false" 
      :clearable="false"
    />

    <v-select 
      v-if="selectedLevel1 && selectedLevel1.children" 
      v-model="selectedLevel2" 
      :options="selectedLevel1.children" 
      label="label" 
      :searchable="false" 
      :clearable="false"
    />

    <v-select 
      v-if="selectedLevel2 && selectedLevel2.children" 
      v-model="selectedLevel3" 
      :options="selectedLevel2.children" 
      label="label" 
      :searchable="false" 
      :clearable="false"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    issueType: Object
  },
  data() {
    return {
      selectedLevel1: null,
      selectedLevel2: null,
      selectedLevel3: null,
      options: [
        { label: this.$t("gameQuestion"), value: 'gamepl_mode_other' },
        { label: this.$t("paymIssue"), value: 'paym_question' },
        { label: this.$t("techIssue"), value: 'tech_other' },
        { label: this.$t("dpo"), value: 'acc_wipe' }
      ],
    }
  },
  computed: {
    selectedIssueType() {
      if (this.selectedLevel3) {
        return this.selectedLevel3
      } else if (this.selectedLevel2) {
        return this.selectedLevel2
      } else {
        return this.selectedLevel1
      }
    }
  },
  watch: {
    selectedLevel1(newValue) {
      this.selectedLevel2 = null
      this.selectedLevel3 = null
    },
    selectedLevel2(newValue) {
      this.selectedLevel3 = null
    },
    selectedIssueType(newValue) {
      this.$emit('update:issue-type', newValue)
    },
    issueType(newValue) {
      let valueToEmit = null

      if (newValue && newValue.value) {
        valueToEmit = newValue.value
      }

      if (this.selectedLevel3 && this.selectedLevel3.value && !this.selectedLevel3.children) {
        valueToEmit = this.selectedLevel3.value
      } else if (this.selectedLevel2 && this.selectedLevel2.value && !this.selectedLevel2.children) {
        valueToEmit = this.selectedLevel2.value
      } else if (this.selectedLevel1 && this.selectedLevel1.value) {
        valueToEmit = this.selectedLevel1.value
      }

      if ((this.selectedLevel1 && this.selectedLevel1.value && this.selectedLevel1.children && !this.selectedLevel2) || 
        (this.selectedLevel2 && this.selectedLevel2.value && this.selectedLevel2.children && !this.selectedLevel3)) {
          valueToEmit = ''
      }

      if (valueToEmit !== null) {
        this.$emit('update:issue-type', valueToEmit)
      }
    }
  }
}

</script>

<style>
@import "vue-select/dist/vue-select.css";

.issue-type,
.gdpr-type {
  --vs-search-input-bg: #8f6743;
  --vs-font-size: 18px;
  --vs-border-color: rgba(255, 255, 255, 0.2);
  --vs-border-width: 1px;
  --vs-border-radius: 0.375rem;
  --vs-controls-color: rgba(255, 255, 255, 0.2);
  --vs-controls-size: 1;
  --vs-selected-color: #ffebab;
  --vs-dropdown-bg: #151c28;
  --vs-dropdown-option--active-bg: #8f6743;
  --vs-state-disabled-cursor: not-allowed;
  -webkit-tap-highlight-color: transparent;
}
.vs--disabled .vs__dropdown-toggle, 
.vs--disabled .vs__search, 
.vs--disabled .vs__open-indicator,
.vs__clear:disabled {
  background-color: #160D06;
  opacity: 0.4;
}
</style>